// Port of api/fuel/app/classes/insights/records/games.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function winThreshold(type, owner, userIndex) {
	var threshold = (type === Constants.TYPE_USER) ? Math.floor(owner.get_hindex() / 2) : (userIndex.length / 2)
	if (threshold > 20) threshold = 20
	if (threshold < 2) threshold = 2
	return threshold
}

function packageGames(segment, games, detail, compareType) {
	var limit = detail ? 100 : 5
	var direction = compareType === 'most' ? 'desc' : 'asc'
	var items = Util.sort_by_field(games, 'ratio', direction).slice(0, limit)

	for (var i = 0; i < items.length; i++) {
		segment._references.users.push(parseInt(items[i].user, 10))
		segment._references.games.push(parseInt(items[i].id, 10))
	}

	return items
}

export default Segment.extend({
	name: 'games',
	requires: ['init'],
	insight: false,
	methods: {
		records_games_analysis: function(type, owner, userIndex) {
			var threshold = winThreshold(type, owner, userIndex)
			var rawGames = Util.queryFast(
				'SELECT pl.game_id AS id, pl.user_id AS user, SUM(pl.play_count) AS total, SUM(pl.play_won) AS wins' +
				' FROM play pl' +
				' WHERE pl.play_result = 1' +
				' AND pl.user_id IN (' + Util.in(userIndex) + ')' +
				' GROUP BY pl.user_id, pl.game_id' +
				' HAVING SUM(pl.play_count) >= ' + threshold
			)

			var games = []
			for (var i = 0; i < rawGames.length; i++) {
				rawGames[i].ratio = (100 / rawGames[i].total) * rawGames[i].wins
				games.push(rawGames[i])
			}
			return games
		}
	},
	run: function(type, owner, userIndex, detail, filter, vars) {
		var threshold = winThreshold(type, owner, userIndex)
		var games = this.records_games_analysis(type, owner, userIndex)

		if (detail) {
			return {
				games: packageGames(this, games, detail, vars.compareType)
			}
		}

		return {
			games: {
				threshold: threshold,
				most: packageGames(this, games, detail, 'most'),
				least: packageGames(this, games, detail, 'least')
			}
		}
	}
})
